module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Akash_Julia.aeb0b36e.jpg";